module.exports = __webpack_public_path__ + "img/multiple.c36185c5.svg";